export default __webpack_public_path__ + "static/Scientist_M_400x650px-a62c12125062c1bf3b3f8ce1466e65cb.png";